import { HttpClient } from '@angular/common/http';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../env.service";
export class ProfileService {
    constructor(http, envService) {
        this.http = http;
        this.apiURL = envService.API_URL;
    }
    getUser(id) {
        const apiUrl = this.apiURL + 'user/' + id.toString();
        return this.http.get(apiUrl);
    }
    getUserByUsername(username) {
        const apiUrl = this.apiURL + 'user/username/' + username;
        return this.http.get(apiUrl);
    }
    getUserPromotions(userId) {
        const apiUrl = this.apiURL + 'user/' + userId + '/promotions';
        return this.http.get(apiUrl);
    }
}
ProfileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProfileService_Factory() { return new ProfileService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EnvService)); }, token: ProfileService, providedIn: "root" });
